/**
 * JS component for the hero section on single test pages.
 */
export function TestHeroComponent() {
  /**
   * Initialize the component
   */
  window.addEventListener('load', () => {
    document.getElementById('test-hero-see-prices')?.addEventListener('click', scrollToPackageOptions);
  });

  /**
   * Scrolls the page to the package options container, below the sticky header.
   */
  function scrollToPackageOptions() {
    const packageOptions = document.querySelector('#package-options');

    if (!packageOptions) {
      return;
    }

    const headerHeight = document.querySelector('.header.sticky')?.offsetHeight ?? 0;
    const top = packageOptions.getBoundingClientRect().top + window.scrollY - headerHeight;

    window.scrollTo({ top, behavior: 'smooth' });
  }
}

window.testHero = new TestHeroComponent();
